import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import VueConfetti from 'vue-confetti'
require('vue2-animate/dist/vue2-animate.min.css')

Vue.use(VueConfetti)
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')
